import type { FC } from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  Typography,
  Unstable_Grid2 as Grid
} from '@mui/material';
// import { Logo } from 'src/components/logo';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';

interface Section {
  title: string;
  items: {
    external?: boolean;
    title: string;
    path: string;
  }[];
}

const sections: Section[] = [
  {
    title: 'Legal',
    items: [
      {
        title: 'Term & Conditions',
        path: '/term-condition'
      },
      {
        title: 'Disclaimer',
        path: '/disclaimer'
      },
      {
        title: 'Privacy Policy',
        path: 'privacy-policy'
      },
      {
        title: 'Contact',
        path: '/contact'
      }
    ]
  },
];
const socialMedia: Section[] = [
  {
    title: 'Social',
    items: [
      {
        title: 'Instagram',
        path: 'https://www.instagram.com/accounts/login/?next=%2Fplatinx.exchange%2F'
      },
      {
        title: 'Facebook',
        path: 'https://www.facebook.com/PlatinX.Exchange#'
      },
      {
        title: 'Twitter',
        path: 'https://x.com/PlatinXExchange'
      }
    ]
  },
];


  
export const Footer: FC = (props) => (
  <Box
    sx={{
      backgroundColor: (theme) => theme.palette.mode === 'dark'
        ? 'neutral.800'
        : 'neutral.50',
      borderTopColor: 'divider',
      borderTopStyle: 'solid',
      borderTopWidth: 1,
      pb: 6,
      pt: {
        md: 15,
        xs: 6
      }
    }}
    {...props}
  >
    <Container maxWidth="lg">
      <Grid
        container
        spacing={3}
      >
         <Grid
          xs={12}
          sm={4}
          md={3}
          sx={{
            order: {
              xs: 4,
              md: 1
            }
          }}
        >
          <Stack spacing={1}>
            <Stack
              alignItems="center"
              component={RouterLink}
              direction="row"
              display="inline-flex"
              href={paths.index}
              spacing={1}
              sx={{ textDecoration: 'none' }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  height: 60,
                  width: 'auto'
                }}
              >
                <Box
                  component="img"
                  src="/assets/swift-ramp-logo.png"
                  alt="SwiftRamp"
                  sx={{
                    height: '100%',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </Box>
            
            </Stack>
          </Stack>
           {/* Add  social icon here */}
            <Stack direction="row"
             spacing={2} 
             mt={5}>
            <Link
              href="https://www.instagram.com/platinx.exchange"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <InstagramIcon sx={{width:30,height:30,color: 'white', backgroundColor: 'primary.main',borderRadius:'50%', p: 0.5  }} />
            </Link>
            <Link
              href="https://x.com/PlatinXExchange"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <TwitterIcon sx={{width:30,height:30,color: 'white', backgroundColor: 'primary.main',borderRadius:'50%', p: 0.5  }}  />
            </Link>
            <Link
              href="https://www.linkedin.com/company/platinx-exchange"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
            >
              <LinkedInIcon  sx={{width:30,height:30,color: 'white', backgroundColor: 'primary.main',borderRadius:'50%', p: 0.5  }} />
            </Link>
          </Stack>

          </Grid>
          {sections.map((section, index) => (
          <Grid
            key={section.title}
            xs={12}
            sm={4}
            md={3}
            sx={{
              order: {
                md: index + 2,
                xs: index + 1
              }
            }}
          >
            <Typography
              color="text.secondary"
              variant="overline"
            >
              {section.title}
            </Typography>
            <Stack
              component="ul"
              spacing={1}
              sx={{
                listStyle: 'none',
                m: 0,
                p: 0
              }}
            >
              {section.items.map((item) => {
                const linkProps = item.path
                  ? item.external
                    ? {
                      component: 'a',
                      href: item.path,
                      target: '_blank'
                    }
                    : {
                      component: RouterLink,
                      to: item.path,
                     
                    }
                  : {};

                return (
                  <Stack
                    alignItems="center"
                    direction="row"
                    key={item.title}
                    spacing={2}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'primary.main',
                        height: 2,
                        width: 12
                      }}
                    />
                    <Link
                      color="text.primary"
                      variant="subtitle2"
                      {...linkProps}
                    >
                      {item.title}
                    </Link>
                  </Stack>
                )
              })}
            </Stack>
          </Grid>
        ))}
          {socialMedia.map((section, index) => (
          <Grid
            key={section.title}
            xs={12}
            sm={4}
            md={3}
            sx={{
              order: {
                md: index + 2,
                xs: index + 1
              }
            }}
          >
            <Typography
              color="text.secondary"
              variant="overline"
            >
              {section.title}
            </Typography>
            <Stack
              component="ul"
              spacing={1}
              sx={{
                listStyle: 'none',
                m: 0,
                p: 0
              }}
            >
              {section.items.map((item) => {
                const linkProps = item.path
                  ? item.external
                    ? {
                      component: 'a',
                      href: item.path,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    }
                    : {
                      component: RouterLink,
                      to: item.path,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    }
                  : {};

                return (
                  <Stack
                    alignItems="center"
                    direction="row"
                    key={item.title}
                    spacing={2}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'primary.main',
                        height: 2,
                        width: 12
                      }}
                    />
                    <Link
                      color="text.primary"
                      variant="subtitle2"
                      {...linkProps}
                    >
                      {item.title}
                    </Link>
                  </Stack>
                )
              })}
            </Stack>
          </Grid>
         ))}
                 {/* Address Section (replacing last socialMedia section) */}
        <Grid
          xs={12}
          sm={3}
          md={3}
          sx={{
            order: {
              xs: socialMedia.length + sections.length + 1,
              md: socialMedia.length + sections.length + 1
            }
          }}
        >
          <Typography
            color="text.secondary"
            variant="overline"
        >
            Contact
          </Typography>
          <Stack
            component="ul"
            spacing={1}
            sx={{
              listStyle: 'none',
              m: 0,
              p: 0
            }}
          >
            <Stack
              alignItems="center"
              direction="row"
              spacing={2}
            >
              <Box
                sx={{
                  backgroundColor: 'primary.main',
                  height: 2,
                  width: 12
                }}
              />
               <Link
                href="mailto:ashish@swift.in"
                underline="hover"
                variant="subtitle2"
                color="text.primary"
              >
              Mail: ashish@swiftramp.in
            </Link>
            </Stack>
            <Stack
              alignItems="center"
              direction="row"
              spacing={2}
            >
              <Box
                sx={{
                  backgroundColor: 'primary.main',
                  height: 2,
                  width: 12
                }}
              />
              <Typography variant="subtitle2" 
              color="text.primary">
              Phone: +91 9560107106
              </Typography>
            </Stack>
            <Stack alignItems="flex-start"
             direction="row"
              spacing={2}>
            <Box sx={{ backgroundColor: 'primary.main', height: 2, width: 12, mt: 1 }} />
            <Link
              href="https://www.google.com/maps/place/Spectrum+@+Metro,+Sector+75,+Noida,+Uttar+Pradesh+201301,+India"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              variant="subtitle2"
              color="text.primary"
            >
              Address: Unit Number - 1919, 19th floor,<br />
              Tower A, Spectrum Metro Mall,<br />
              Sector 75, Noida-201301, India
            </Link>
    </Stack>
          </Stack>
        </Grid>

        {/* add  the address grid */}
    

      </Grid>
      <Divider sx={{ my: 6 }} />
      <Typography
        color="text.secondary"
        variant="caption"
      >
        All Rights Reserved.
      </Typography>
    </Container>
  </Box>
);
